module.exports = __webpack_public_path__ + "static/media/Video.217a980b.jpg";